module.exports = __webpack_public_path__ + "img/multiply14-2.c466cd61.svg";